<template>
  <v-select :items="genders" v-model="value" :label="label"></v-select>
</template>

<script>
import { Vue, Component } from "vue-property-decorator";

@Component({
  name: "CampusSelect",
  props: {
    value: {
      default: 1
    },
    label: {
      default: "Gender"
    },
    clearable: {
      default: false
    },
    rules: {
      default: () => []
    }
  }
})
export default class extends Vue {
  genders = [
    {
      text: "Male",
      value: 1
    },
    {
      text: "Female",
      value: 0
    },
    {
      text: "Others",
      value: 2
    }
  ];
}
</script>